import React, {useState} from "react";
import {Model} from "../Model";
import Toolbar from "@mui/material/Toolbar";
// @ts-ignore
import logo from "../../assets/img/logo.png";
import {ProfilePicture} from "../common/ProfilePicture";
import {Typography} from "@mui/material";
import {Icon} from "@iconify/react";
import {EditProfile} from "../ModelComponents/EditProfile";
import {initializeRole, initializeToken, initializeUrl, initializeUser, User} from "../../app/features/Auth";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../app/store";
import {orignalURI, setAxiosToken} from "../../http-common";
import {RoutesList} from "../../Modules/RoutesList";
import {useNavigate} from "react-router-dom";



export const UserDetails = () =>{

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const __role = useSelector(((state:RootState) => state.auth.role))
    const [model,setModel] = useState<boolean>(false)
    const handleOpen = () => setModel(true)
    const handleClose = () => setModel(false)

    const modelComponent = ()=>{
        return (
            <EditProfile handleClose={handleClose} />
        )
    }

    const switchCompany = () =>{
        let supremeToken = localStorage.getItem('supreme-token')!
        let role = 'supreme-admin'

        setAxiosToken(supremeToken)
        //
        localStorage.setItem("user_role",role)
        //
        dispatch(initializeToken(supremeToken))
        dispatch(initializeRole(role))
        dispatch(initializeUrl(orignalURI))
        navigate(RoutesList.AllClients.path)
    }

    const renderName = () =>{

        return("Super-Admin")
        // if(_user == null)
        //     return (
        //         " "
        //     );
        // else{
        //     return ( `${_user.first_name} ${_user.last_name}` )
        // }
    }

    return(
        <div>
            <Model
                open={model}
                handleClose={handleClose}
                Component = {modelComponent}
            />
            <Toolbar sx={{justifyContent:"center",flexWrap:"wrap",padding:"10px"}}>
                <div className = "logo-portrait">
                    <img src={logo} />
                </div>
                <ProfilePicture/>
                <Typography width={100} fontWeight={700} fontSize="16px" padding="10px 0px" style={{textAlign: "center"}}>
                    {
                        renderName()
                    }
                </Typography>
                {/*<Typography  color="#8F95B2" onClick={handleOpen} sx={{cursor:"pointer"}}>*/}
                {/*    <Icon icon="fa-solid:edit" /> Edit Profile*/}
                {/*</Typography>*/}

                {
                    __role === 'super-admin'?
                        <Typography  color="#8F95B2" onClick={switchCompany} sx={{cursor:"pointer"}}>
                            <Icon icon="clarity:switch-line" /> Switch Company
                        </Typography>
                        :''
                }
            </Toolbar>
        </div>
    )
}